import React from 'react';
import { createRoot } from 'react-dom/client';
import { Buffer } from 'buffer';

import AppointmentForm from '@espacePro/components/AppointmentCustomForm/components/AppointmentForm';

document.addEventListener('DOMContentLoaded', () => {
  const meeting = document.getElementById(
    'react-meetings-contact-widget',
  );

  const settings = meeting.getAttribute('data-settings');
  const decoded = Buffer.from(settings, 'base64').toString();
  const parameters = JSON.parse(decoded);

  const root = createRoot(meeting);
  root.render(
    <AppointmentForm
      meetingSubjects={parameters.meetingSubjects}
      schools={parameters.schools}
      sections={parameters.sections}
      formColors={parameters.formColors}
      isSchoolsLoading={false}
      isSubjectsLoading={false}
      schoolId={parameters.schoolId}
    />,
  );
});
